import { render } from "./TeacherGradingWorkspaceView.vue?vue&type=template&id=d3669a1a&scoped=true"
import script from "./TeacherGradingWorkspaceView.vue?vue&type=script&lang=js"
export * from "./TeacherGradingWorkspaceView.vue?vue&type=script&lang=js"

import "./TeacherGradingWorkspaceView.vue?vue&type=style&index=0&id=d3669a1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3669a1a"]])

export default __exports__